import apiClient from '../lib/axios';

export interface SmsLog {
  id: string;
  recipientId: string;
  recipientName?: string;
  phoneNumber?: string;
  messageText: string;
  status: string;
  scheduledDate?: string;
  sentAt?: string;
  deliveredAt?: string;
  errorMessage?: string;
  retryCount: number;
  createdAt: string;
  /** Server-derived: the send was faked and never reached a phone. */
  simulated: boolean;
}

export interface SendTestResult {
  messageId: string;
  charge: number | null;
  deliveryStatus: string;
  /** True when the stub provider handled the send and nothing reached a phone. */
  simulated: boolean;
}

class SmsService {
  async sendTest(payload: { phone: string; message: string }): Promise<SendTestResult> {
    const response = await apiClient.post('/sms/test', payload);
    return response.data.data;
  }

  async getLogs(params: { page?: number; limit?: number; status?: string; startDate?: string; endDate?: string }) {
    const response = await apiClient.get('/reminders', { params });
    const raw = response.data;

    // Map ReminderJob fields to SmsLog fields
    const data = (raw.data || []).map((r: any) => ({
      id: r.id,
      recipientId: r.recipientId,
      recipientName: r.recipient?.caregiverName || null,
      phoneNumber: r.recipient?.phoneNumber || null,
      messageText: r.message,
      status: r.status,
      scheduledDate: r.sendAt,
      sentAt: r.sentAt,
      deliveredAt: r.deliveredAt,
      errorMessage: r.errorMessage,
      retryCount: r.retryCount || 0,
      createdAt: r.createdAt,
      simulated: r.simulated === true,
    }));

    return {
      data,
      pagination: raw.pagination,
    };
  }
}

export const smsService = new SmsService();
